module.exports = __webpack_public_path__ + "static/media/game-play.6c1c4955.mp3";